import React, { useState } from "react";
import Tabs from "../Tabs";
import OrganisationContent from "./subtabsOrganisationdesign/OrganisationContent";
import ListingContent from "./subtabsOrganisationdesign/ListingContent";
import Button from "../../form/Button";
import EventOrganisationContent from "./subtabsOrganisationdesign/EventOrganisationContent";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import LangSwitch from "../LangSwitch";

const OrganisationDesign = ({
  data = {},
  organizationDetailsRefetch = () => {},
}) => {
  const { t } = useTranslation();
  const { lang } = useSelector((state) => state?.langProvider);
  const [selectedLang, setSelectedLang] = useState(lang || "en");
  const [selectedTab, setSelectedTab] = useState(0);

  const tabItems = [
    {
      label: t("Organization"),
      content: (
        <OrganisationContent
          data={data}
          organizationDetailsRefetch={organizationDetailsRefetch}
          selectedLang={selectedLang}
        />
      ),
    },
    {
      label: t("Listing page"),
      content: (
        <ListingContent
          data={data}
          organizationDetailsRefetch={organizationDetailsRefetch}
          selectedLang={selectedLang}
        />
      ),
    },
    {
      label: t("Event pages"),
      content: (
        <EventOrganisationContent
          data={data}
          organizationDetailsRefetch={organizationDetailsRefetch}
          selectedLang={selectedLang}
        />
      ),
    },
  ];

  return (
    <>
      <div className="bg-white space-y-4 py-4 px-4 rounded-md">
        <LangSwitch
          langs={["en", "es"]}
          selectedLang={selectedLang}
          setSelectedLang={setSelectedLang}
        />
        <Tabs
          selectedIndex={selectedTab}
          setSelectedIndex={setSelectedTab}
          items={tabItems}
          contentClass={"w-full px-0"}
          tabsClass="gap-3 p-3 md:p-5 flex items-center gap-4 shadow-lg rounded-lg border-t border-slate-100 overflow-auto"
          tabClass={
            "h-11 rounded-full bg-transparent border border-gray-200 flex items-center justify-center !text-deep-purple p-5 text-base capitalize font-normal"
          }
          activeTabClass={"bg-primary border border-primary !text-white"}
        />
      </div>
      {/* <div className="flex mt-7 gap-3 justify-end bg-magnolia py-4 sticky bottom-0 right-0 z-[2] pr-6">
        <Button buttonLabel={"Publish changes"} />
      </div> */}
    </>
  );
};

export default OrganisationDesign;
